import { Icon, typography } from '@joor/design-system'
import styled, { css } from 'styled-components'

export const Container = styled.div<{ $hasSelection: boolean }>`
  ${({ $hasSelection }) =>
    !$hasSelection
      ? css`
          display: block;
        `
      : css`
          display: flex;
          flex-wrap: wrap;
        `}
  gap: 8px;
  padding: 16px 8px;
`

export const NoFilters = styled.div`
  text-align: center;
  color: var(--color-primary-200);
`

export const Chip = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: fit-content;
  padding: 4px 4px 4px 8px;
  ${typography.alpha.primaryActive.caption}
  line-height: 12px;
  color: var(--color-primary-900);
  background-color: var(--color-secondary-200);
  border-radius: 10px;
`

export const StyledIcon = styled(Icon)`
  cursor: pointer;

  svg {
    --main-color: var(--color-neutral-800);
  }
`
